module.exports={
  "nypd": {
    "color": "#f78e65",
    "background": "#fda584",
    "label": "NYPD",
    "date": "2021-03-21"
  },
  "education": {
    "color": "#848c73",
    "background": "#a8b18c",
    "label": "Education",
    "date": "2021-03-21"
  },
  "corona-recovery": {
    "color": "#b98fc1",
    "background": "#c9b6ca",
    "label": "COVID Recovery",
    "date": "2021-03-21"
  },
  "transportation": {
    "color": "#6e8e83",
    "background": "#8cafa6",
    "label": "Transportation",
    "date": "2021-03-30"
  },
  "housing": {
    "color": "#a85d71",
    "background": "#dd94a4",
    "label": "Housing",
    "date": "2021-04-12"
  },
  "immigration": {
    "color": "#4b81aa",
    "background": "#8ca7c4",
    "label": "Immigration",
    "date": "2021-04-19"
  },
  "labor": {
    "color": "#a871a3",
    "background": "#c69bbd",
    "label": "Labor",
    "date": "2021-04-27"
  },
  "criminal-justice": {
    "color": "#559997",
    "background": "#99bebf",
    "label": "Criminal Justice",
    "date": "2021-05-03"
  },
  "taxes": {
    "color": "#ef975b",
    "background": "#f7bd92",
    "label": "Taxes",
    "date": "2021-05-10"
  },
  "borough": {
    "color": "#789671",
    "background": "#95af90",
    "label": "Borough Edition",
    "date": "2021-05-17"
  },
  "leadership": {
    "color": "#678d99",
    "background": "#a2c0cc",
    "label": "Leadership",
    "date": "2021-05-23"
  },
  "homelessness": {
    "color": "#d67070",
    "background": "#da9a9d",
    "label": "Homelessness",
    "date": "2021-05-24"
  },
  "climate-change": {
    "color": "#899376",
    "background": "#afb7a5",
    "label": "Climate Change",
    "date": "2021-05-25"
  },
  "building-nyc": {
    "color": "#7f7fba",
    "background": "#9f9fc4",
    "label": "Building NYC Better",
    "date": "2021-05-26"
  },
  "quality-of-life": {
    "color": "#5d7baf",
    "background": "#97a3c6",
    "label": "Quality of Life",
    "date": "2021-05-27"
  },
  "general-election": {
    "color": "#1B71B3",
    "background": "#648EC2",
    "label": "General Election",
    "date": "2021-10-19"
  }
}